const AVATAR_PALETTE = [
  "bg-violet-500", "bg-indigo-500", "bg-sky-500", "bg-teal-500",
  "bg-emerald-500", "bg-amber-500", "bg-rose-500", "bg-pink-500",
  "bg-orange-500", "bg-cyan-500",
];

function avatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? "?";
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

interface Props {
  name: string;
  photoUrl?: string | null;
  size?: "sm" | "md" | "lg";
}

const SIZE = {
  sm: "h-8 w-8 text-[11px]",
  md: "h-11 w-11 text-sm",
  lg: "h-14 w-14 text-base",
};

export default function ConsultantAvatar({ name, photoUrl, size = "sm" }: Props) {
  const sizeClass = SIZE[size];
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        className={`${sizeClass} rounded-full object-cover shrink-0 ring-2 ring-white dark:ring-slate-800`}
      />
    );
  }
  return (
    <span className={`${sizeClass} rounded-full flex items-center justify-center font-bold text-white shrink-0 ring-2 ring-white dark:ring-slate-800 ${avatarColor(name)}`}>
      {initials(name)}
    </span>
  );
}
